module.exports = __webpack_public_path__ + "media/images/landing/appstore-a2e08431132c8998f3bf544b6354e874.svg";